import React, { useEffect, useState } from 'react'
import BreadCrames from '../component/BreadCrames'
import { sidebarAction } from '../redux/SidebarSlice'
import ApiConnection from '../utils/ApiConnection'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import Loader from '../utils/Loader'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

const ChangePassword = () => {

    const [loading, setloading] = useState(false)
    const [oldpassword, setoldpassword] = useState("")
    const [newpassword, setnewpassword] = useState("")
    const [confirmpassword, setconfirmpassword] = useState("")

    const [etype, seteType] = useState('password');
    const [eicon, seteIcon] = useState( <FontAwesomeIcon icon={faEyeSlash} />);
    const [ntype, setnType] = useState('password');
    const [nicon, setnIcon] = useState( <FontAwesomeIcon icon={faEyeSlash} />);
    const [ctype, setcType] = useState('password');
    const [cicon, setcIcon] = useState( <FontAwesomeIcon icon={faEyeSlash} />);






    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(sidebarAction(false)) 
      },[])

      let navigate = useNavigate()

      const SubmitHandler = async () =>{
        if(oldpassword == ''){
            toast.error("Existing password is required");
          } else if(newpassword == ''){
            toast.error("New Password is required");
          } else if(newpassword !== confirmpassword){
            toast.error("Confirm Password does not match");
          } else {
            setloading(true)
            try{
                var FormData = require('form-data');
                var data = new FormData();
                data.append('existing_password', oldpassword);
                data.append('password', newpassword);
                data.append('c_password', confirmpassword);
                const response = await ApiConnection.post(`change-password`, data);
                if(response.status === 200){
                    setloading(false)
                    toast.success(response?.data?.message);
                    navigate("/dashboard")
                } else {
                    setloading(false)
                }

            } catch(err){
                setloading(false)
                if(err.response.status === 500){
                      toast.error(err.response?.data?.message);   
                  
                }
        }
          }
    }

    const handleExistingToggle = () => {
      if (etype==='password'){
         seteIcon(<FontAwesomeIcon icon={faEye} />);
         seteType('text')
      } else {
         seteIcon(<FontAwesomeIcon icon={faEyeSlash} />)
         seteType('password')
      }
   }
   const handleNewToggle = () => {
    if (ntype==='password'){
       setnIcon(<FontAwesomeIcon icon={faEye} />);
       setnType('text')
    } else {
       setnIcon(<FontAwesomeIcon icon={faEyeSlash} />)
       setnType('password')
    }
 }
 const handleConfirmToggle = () => {
  if (ctype==='password'){
     setcIcon(<FontAwesomeIcon icon={faEye} />);
     setcType('text')
  } else {
     setcIcon(<FontAwesomeIcon icon={faEyeSlash} />)
     setcType('password')
  }
}



  return (
    <>
       {loading && <Loader/>}
    <BreadCrames page="Change Password" />
    <div className='px-4'>
        <div className='card'>
            <div className='card-header'>
                New Password Set
            </div>
            <div className='card-body'>
            <div className='row'>
            <div className='col-lg-6'>
                <div className='form-group'>
                    <label>Existing Password</label>
                    <input type={etype} className="form-control" placeholder="XXXXXXX"
                      value={oldpassword}  
                      onChange={(e)=>setoldpassword(e.target.value)}
                    />
                    <span class="flex justify-around items-center" style={{    
                    position: 'absolute',
top: '43px',
right: '18px'}} onClick={handleExistingToggle}>
               {eicon}
                  
                </span>
                </div>
            </div>
            <div className='col-lg-6'>
                <div className='form-group'>
                    <label>New Password</label>
                    <input type={ntype} className="form-control" placeholder="XXXXXXX"
                    value={newpassword}  
                    onChange={(e)=>setnewpassword(e.target.value)}
                    />
                      <span class="flex justify-around items-center" style={{    
                    position: 'absolute',
top: '43px',
right: '18px'}} onClick={handleNewToggle}>
               {nicon}
                  
                </span>
                </div>
            </div>
            <div className='col-lg-6'>
                <div className='form-group'>
                    <label>Confirm New Password</label>
                    <input type={ctype} className="form-control" placeholder="XXXXXXX"
                     value={confirmpassword}  
                     onChange={(e)=>setconfirmpassword(e.target.value)}
                    />
                      <span class="flex justify-around items-center" style={{    
                    position: 'absolute',
top: '43px',
right: '18px'}} onClick={handleConfirmToggle}>
               {cicon}
                  
                </span>
                </div>
            </div>
          
            <div className='col-lg-12 mt-2'>
     <div className='form-group text-right'>
                <button type='button' className='btn btn-primary' onClick={SubmitHandler}>Update</button>
            </div>
            </div>
            </div>
            </div>
        </div>
    </div>
</>
  )
}

export default ChangePassword